export default {
  English: 'English',
  Français: 'French',
  Deutsch: 'German',
  Italliano: 'Italian',
  Español: 'Spanish',
  Next: 'Next',
  Back: 'Back',

  // META DATA in general file
  // TOP LINE PAY LATER in general file
  // PAY LATER MODAL INFO WINDOW  in general file
  // STEP 1 TILES in general file
  // STEP2  in general file

  // STEP3 -- partially in general file (title and All you can eat bundle)
  TILE_BUNDLE_MAIN_TITLE: '<b>Duplicate Killer + 3 Bundle</b>',
  TILE_BUNDLE_MAIN_TITLE_DIV: 'Duplicate Killer + 3 Bundle',
  TILE_BUNDLE_MAIN_DESCRIPTION1: 'Add backup, import-export and repair toolbox',
  TILE_BUNDLE_MAIN_TITLE_MODAL: '<b>Duplicate Killer + 3 Bundle</b>',
  TILE_BUNDLE_MAIN_DESCRIPTION_MODAL: 'Buy Duplicate Killer + 3 Bundle and you will receive:',
  TILE_BUNDLE_MAIN_S2_DESCRIPTION: ' - Synchronize Microsoft Outlook data between multiple PC’s.',
  TILE_BUNDLE_MAIN_S2C_DESCRIPTION: ' - Synchronize Microsoft outlook data with multiple sources: iCloud, Google, Microsoft Exchange.',
  TILE_BUNDLE_MAIN_DR_DESCRIPTION: ' - find and remove Outlook duplicate items in just one click.',
  TILE_BUNDLE_MAIN_DK_DESCRIPTION: ' - manage duplicate items in the Contacts, E-mails, Notes, Tasks, Calendar Folders of Microsoft Outlook. ',
  TILE_BUNDLE_MAIN_SPB_DESCRIPTION: ' - automatic Outlook PST and Exchange folders backup tool.',
  TILE_BUNDLE_MAIN_OT_DESCRIPTION: ' - resolve Outlook problems with Outlook toolbox.',

  TILE_BUNDLE_MAIN_OST2_DESCRIPTION: ' - Convert OST to PST files and connect converted files to Microsoft Outlook',
  TILE_BUNDLE_MAIN_SPLITTER_DESCRIPTION: ' - Split your PST file automatically or manually.',
  TILE_BUNDLE_MAIN_MERGER_DESCRIPTION: ' - Merge multiple PST files into a single file.',
  TILE_BUNDLE_MAIN_VIEWER_DESCRIPTION: ' - View PST and OST files in a few clicks without Microsoft Outlook.',
  TILE_BUNDLE_MAIN_S2_NAME: 'Sync2',
  TILE_BUNDLE_MAIN_S2_URL: 'https://www.sync2.com/',
  TILE_BUNDLE_MAIN_S2C_NAME: 'Sync2 Cloud',
  TILE_BUNDLE_MAIN_S2C_URL: 'https://cloud.sync2.com/',
  TILE_BUNDLE_MAIN_DR_NAME: 'Outlook Duplicate Remover',
  TILE_BUNDLE_MAIN_DR_URL: 'https://www.duplicate-remover.com/',
  TILE_BUNDLE_MAIN_DK_NAME: 'Duplicate Killer',
  TILE_BUNDLE_MAIN_DK_URL: 'https://www.duplicatekiller.com/',
  TILE_BUNDLE_MAIN_SPB_NAME: 'Safe PST Backup',
  TILE_BUNDLE_MAIN_SPB_URL: 'https://www.safepstbackup.com/',
  TILE_BUNDLE_MAIN_OT_NAME: 'Outlook Toolbox',
  TILE_BUNDLE_MAIN_OT_URL: 'https://outlooksupport.4team.biz/resolve-outlook-problems-with-outlook-toolbox',
  TILE_BUNDLE_MAIN_OST2_NAME: 'OST2',
  TILE_BUNDLE_MAIN_OST2_URL: 'https://www.ost2.com/',
  TILE_BUNDLE_MAIN_SPLITTER_NAME: 'PST Splitter',
  TILE_BUNDLE_MAIN_SPLITTER_URL: 'http://www.pst-file-splitter.com/',
  TILE_BUNDLE_MAIN_MERGER_NAME: 'PST Merger',
  TILE_BUNDLE_MAIN_MERGER_URL: 'http://www.pst-merger.com/',
  TILE_BUNDLE_MAIN_VIEWER_NAME: 'OST PST Viewer',
  TILE_BUNDLE_MAIN_VIEWER_URL: 'https://www.ostpstviewer.com/',

  // STEP4  in general file
  // Tiles buttons  in general file
  // Tiles links  in general file
  // Tiles Price & Save  in general file

  // MODAL WHY UPGRADE
  MODAL_WHY_UPGRADE_TITLE: 'Why Renew?',
  MODAL_WHY_UPGRADE_DESCTIPTION:
    'With the User License Renewal purchase, you will receive <b>1 year of free software upgrades</b> as well as our <b>free online support via Live Chat</b><br> <b>We highly recommend upgrading your software license annually.</b>',
  MODAL_WHY_UPGRADE_PURCHASE_TITLE: 'How to Purchase the License Renewal?',
  MODAL_WHY_UPGRADE_PURCHASE_TEXT:
    'If you have used the product for more than 1 year and want an upgrade, please select <b>Product Renewal</b>. Then in the shopping cart please select license quantity that you own and want to upgrade. After the order confirmation you are eligable to use the upgraded version of the software for another year.<br><br>Your original license is valid indefinately. If you save the original downloadable program file, you will be able to use it at any time in the future.<br><br>Every user needs an individual license for each PC. If two users use the same PC, they will need two licenses, if they log in to different Windows profiles.',

  // MODAL WHY UPGRADE in general file
  // MODAL WHY LIFETIME UPGRADE in general file
  // MODAL WHY SUBSCRIPTION UPGRADE in general file
  // MODAL BUNDLES ADDITIONAL TEXT   in general file
  // MODAL LIFETIME ADDITIONAL TEXT   in general file
  // PURCHASE STEPS BAR --   in general file
  // NOTES AND PAYMENT CARDS ICONS in general file
  // INFO LINKS--   in general file
  // FOOTER--   in general file
  // EMAIL VALIDATION--   in general file

  // burger menu
  MENU_DOWNLOAD: 'Download',
  MENU_DOWNLOAD_TITLE: 'Click here to download Duplicate Killer',
  MENU_FEATURES: 'Features',
  MENU_FEATURES_TITLE: 'Take a Tour (How to sync Outlook. Sync Outlook with Google.)',
  MENU_PRICING: 'Pricing',
  MENU_PRICING_TITLE: 'Pricing',
  MENU_TESTIMONIALS: 'Testimonials',
  MENU_TESTIMONIALS_TITLE: 'Click here to view Duplicate Killer reviews, customer testimonials and feedbacks',
  MENU_FAQ: 'FAQ',
  MENU_FAQ_TITLE: 'Click here to read frequently asked questions',
  MENU_SUPPORT: 'Support',
  MENU_SUPPORT_TITLE: 'Support',
  MENU_RESOURCES: 'Resources',
  MENU_RESOURCES_TITLE: 'Resources',
  MENU_RESOURCES_SCREENSHOTS_VIDEO: 'Screenshots & Videos',
  MENU_RESOURCES_SCREENSHOTS_VIDEO_TITLE: 'Screenshots & Videos',
  MENU_RESOURCES_DOCUMENTATION: 'Documentation',
  MENU_RESOURCES_DOCUMENTATION_TITLE: 'Documentation',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS: 'Installation Instructions',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS_TITLE: 'Installation Instructions',
  MENU_RESOURCES_VERSION_HISTORY: 'Version history',
  MENU_RESOURCES_VERSION_HISTORY_TITLE: 'Version history',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS: 'System requirements',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS_TITLE: 'System requirements',
  MENU_RESOURCES_FAQ: 'Frequently Asked Questions',
  MENU_RESOURCES_FAQ_TITLE: 'Frequently Asked Questions',
  MENU_RESOURCES_HELP: 'Help',
  MENU_RESOURCES_HELP_TITLE: 'Help',
  MENU_MY_ACCOUNT: 'My Account',
  MENU_MY_ACCOUNT_TITLE: 'Review your account details',
  MENU_SELECT_LANG: 'Select Your Language',
  MENU_SELECT_LANG_TITLE: 'Select Your Language',
  MENU_CLOSE: 'Close',

  // PAGE LINKS:
  URL_ABOUT_US: "https://www.4team.biz/about.aspx",
  URL_LICENSING: "https://www.4team.biz/eula.aspx",
  URL_FAQ: "https://www.duplicatekiller.com/frequently-asked-questions.aspx",
  URL_SYSTEM_REQUIREMENTS: "https://www.duplicatekiller.com/system-requirements.aspx",
  URL_SUPPORT: "https://www.4team.biz/livehelp.aspx",
  URL_REFUND_POLICY: "https://www.duplicatekiller.com/refundpolicy.aspx",

  // structured data
  SD_PR_NAME: "Duplicate Killer",
  SD_PR_DESCRIPTION: "Purchase, buy #PR_NAME# license and activation code. Order Outlook Tech Support and #PR_NAME# bundle.",
  SD_PR_IMAGE: "https://www.duplicatekiller.com/i/logo.png",
  SD_PR_OPERATING_SYSTEM: "Windows",
  SD_PR_VERSION: "3.51.0696",
  SD_PR_CATEGORY: "Productivity",
  SD_PR_DOWNLOAD_URL: "https://www.duplicatekiller.com/download.aspx",
  SD_PR_RELEASE_NOTES: "https://www.duplicatekiller.com/version-history.aspx",
  SD_PR_AUTHOR_NAME: "4Team Corporation",
  SD_PR_URL: "https://www.duplicatekiller.com/",

  SD_OFFERS_PRICE_CURRENCY_USD: "USD",
  SD_OFFERS_PRICE_USD: "29.95",
  SD_OFFERS_URL_USD: "https://www.duplicatekiller.com/purchase/licenses",

  SD_OFFERS_PRICE_CURRENCY_GBP: "GBP",
  SD_OFFERS_PRICE_GBP: "24.95",
  SD_OFFERS_URL_GBP: "https://www.duplicatekiller.com/purchase/licenses",

  SD_OFFERS_PRICE_CURRENCY_EUR: "EUR",
  SD_OFFERS_PRICE_EUR: "29.95",
  SD_OFFERS_URL_EUR: "https://www.duplicatekiller.com/purchase/licenses",

  SD_RATING_WORST: "1",
  SD_RATING_BEST: "5",
  SD_RATING_VALUE: "4.9",
  SD_RATING_COUNT: "340",

  SD_ORGANIZATION_NAME: "4Team Corporation",
  SD_ORGANIZATION_IMAGE: "https://www.4team.biz/i/4Team_logo_2.png",
  SD_ORGANIZATION_URL: "https://www.4team.biz",
  SD_ORGANIZATION_ADDRESS: "5645 Coral Ridge Dr #211",
  SD_ORGANIZATION_CITY: "Coral Springs",
  SD_ORGANIZATION_REGION: "FL",
  SD_ORGANIZATION_ZIP: "33076",
  SD_ORGANIZATION_COUNTRY: "USA",
  SD_ORGANIZATION_PHONE_USA: " +1 (954) 796-8161",
  SD_ORGANIZATION_PHONE_UK: " +44 20 3371 8464",
  SD_ORGANIZATION_PHONE_CANADA: "+1 647 477-3340",
  SD_ORGANIZATION_PHONE_FRANCE: "+33 1 86 26 42",
  //end structured data

}
